// Global object store that can be accessed without React hooks
class ObjectStore {
  private currentObject: string | null = 'terminals'
  private listeners: Array<(object: string | null) => void> = []

  setObject(object: string | null) {
    this.currentObject = object
    this.listeners.forEach((listener) => listener(object))
  }

  getObject(): string | null {
    return this.currentObject
  }

  subscribe(listener: (object: string | null) => void) {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener)
    }
  }
}

export const objectStore = new ObjectStore()
